import React from "react";
import Card from "@cc/react-components/Card";
import Page from "@cc/react-components/Page";
import ListGroup from "ui/ListGroup";
import {
  allPaymentMethods,
  PaymentMethodEnum,
  translateKey,
} from "common/enums/PaymentMethodEnum";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import PaymentAmount from "main/Payment/PaymentAmount";

interface Props {
  defaultPayedAmount: number;
  payedAmount?: number;
  paymentMethod: PaymentMethodEnum;
  setPaymentMethod(paymentMethod: PaymentMethodEnum): void;
  setPayedAmount(amount: number): void;
}

const Payment = ({
  defaultPayedAmount,
  payedAmount,
  paymentMethod,
  setPaymentMethod,
  setPayedAmount,
}: Props) => {
  const [t] = useTranslation();
  return (
    <Page>
      <Page.Body>
        <Card>
          <Card.Header>
            <Card.Title>
              {t("attestation.payedAmount") + " "}
              <PaymentAmount
                defaultPayedAmount={defaultPayedAmount}
                payedAmount={payedAmount}
                setPayedAmount={setPayedAmount}
              />
            </Card.Title>
          </Card.Header>
        </Card>
        {renderPaymentMethods(paymentMethod, setPaymentMethod, t)}
      </Page.Body>
    </Page>
  );
};

const renderPaymentMethods = (
  payment: PaymentMethodEnum,
  setPaymentMethod: (method: PaymentMethodEnum) => void,
  t: TFunction
) => {
  return (
    <ListGroup>
      {allPaymentMethods().map((paymentEnum, index) => (
        <ListGroup.ItemMobile
          key={index}
          active={payment === paymentEnum}
          onClick={() => setPaymentMethod(paymentEnum)}
        >
          {t(translateKey(PaymentMethodEnum[paymentEnum]))}
        </ListGroup.ItemMobile>
      ))}
    </ListGroup>
  );
};
export default Payment;
